import { apiCall } from '../../api/ServerApi';
import { API_URL_PATHS } from '../../consts/ApiUrlPaths';
import { SeveritiesDisplayMode } from '../../consts/severity';
import { ProductType, TenantProduct } from '../../interfaces/Tenant';
import { logger } from '../Logger';

const { CENTRAL_CONFIG_PATH } = API_URL_PATHS;
export type TConfiguration = Record<string, Record<string, unknown>> & {
	GLOBAL?: TGlobalConfiguration;
} & {
	CONFIG?: {
		EXPORT_JSON_API?: {
			displayName: string;
			endpointUrl: string;
		};
		VIEW_SEVERITIES_DISPLAY_MODE?: SeveritiesDisplayMode;
		/**
		 * Space-separated Azure DevOps OAuth scope *names* (e.g. `vso.profile vso.work_write`),
		 * resolved per tenant. The resource id is a constant in code; these names override the
		 * `VITE_AZURE_SCOPES` env var. See `buildAzureTicketCreatorConfig`.
		 */
		AZURE_SCOPES?: string;
	};
};

type TGlobalConfiguration = {
	CONFIG?: {
		SLACK_CHATBOT?: { link: string; name: string };
		MS_TEAMS_CHATBOT?: { link: string; name: string };
	};
	TOGGLES?: Record<string, unknown>;
};
const getScannerProductID = (products: TenantProduct[]): string => {
	if (!products) {
		return undefined;
	}
	return products.find((product: TenantProduct) => product.type === ProductType.SCANNER)?.id;
};

export const getCentralConfig = async (products: TenantProduct[]): Promise<TConfiguration> => {
	const scannerProductID = getScannerProductID(products);
	if (scannerProductID) {
		try {
			const configurationResult: {
				SITE_SCANNER_UI: TConfiguration;
				GLOBAL: TGlobalConfiguration;
			} = await apiCall(
				'GET',
				`${CENTRAL_CONFIG_PATH}?productId=${scannerProductID}&subPath=SITE_SCANNER_UI,GLOBAL`,
				{ isConfigUrl: true }
			);

			const globalConfig = configurationResult?.GLOBAL || undefined;
			const siteScannerConfig = configurationResult?.SITE_SCANNER_UI || undefined;

			// If there's no SITE_SCANNER_UI config, return undefined
			if (!siteScannerConfig) {
				return undefined;
			}

			const mergedConfig = {
				...siteScannerConfig,
				...(globalConfig && { GLOBAL: globalConfig })
			};

			return mergedConfig;
		} catch (error) {
			logger.error('Error fetching central configuration', error);
			return undefined;
		}
	}
	return undefined;
};
